
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { StringsMixin, BAIconsMixin, RoutingMixin } from '@/mixins';
import { WebLink } from '@/../types';

@Component
export default class WeblinksCard extends Mixins(StringsMixin, BAIconsMixin, RoutingMixin) {
	@Prop({required: true}) weblinks!: Array<WebLink>

	isWeblinksChanging: boolean = false;
	isWeblinksChanged: boolean = false;
	isWeblinksValid: boolean = true;
	onWeblinkAdd() {
		this.isWeblinksChanging = true;
		if( this.IsEmpty(this.weblinks) ) this.weblinks = [];
		this.weblinks.push({label:'', url:''});
		this.isWeblinksChanging = false;
	}
	onWeblinkDelete(index: number) {
		this.isWeblinksChanging = true;
		this.weblinks.splice(index, 1);
		this.isWeblinksChanged = true;
		this.isWeblinksChanging = false;
	}
	onWeblinkChange() {
		this.isWeblinksChanging = true;
		this.isWeblinksChanged = true;
		this.isWeblinksValid = this.weblinks.every(l => this.IsValidUrl(l.url))
		this.isWeblinksChanging = false;
	}
	onSaveChanges() {
		this.$emit('save', this.weblinks);
		this.isWeblinksChanged = false;
	}
}
